// extracted by mini-css-extract-plugin
export default {"editor":"crop_editor__i9Xmt","banner":"crop_banner__pzMy3","cropper":"crop_cropper__DOX2+","slide-in-bottom":"crop_slide-in-bottom__gB6jM"};